module.exports = __webpack_public_path__ + "img/logo14.4daba967.png";